export default () => ({
  listRoot: {
    height: 275,
    overflowY: 'auto',
  },
  labelContainer: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
  },
  infoIcon: {
    fontSize: '14px',
    lineHeight: '14px',
    marginLeft: 4,
  },
  header: { display: 'flex' },
});
